import React, { useState } from "react";
import { Image, Modal, Button, Col, Row } from "react-bootstrap";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  ORDER_TYPE_FILTER,
  PAYMENT_TYPE_FILTER,
  PAYMENT_METHOD_STATUS_FILTER,
} from "../../../../enums/OrderEnums";
import { PopupInsideButton } from "../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import Media from "react-media";

const OrderFilterSection = (props) => {
  const [state, setState] = useState({
    open: false,
  });
  const [orderType, setOrderType] = useState(false);
  const [paymentType, setPaymentType] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState(false);
  const [orderTypeText, setOrderTypeText] = useState(10);
  const [paymentTypeText, setPaymentTypeText] = useState(10);
  const [paymentStatusText, setPaymentStatusText] = useState(10);

  const onOpenModal = () => {
    setState({ open: true });
  };

  const handleCloseModal = () => {
    setState({ open: false });
  };

  const onClickOrderType = (id) => {
    setOrderTypeText(id);
  };

  const onClickPaymentType = (data) => {
    setPaymentTypeText(data);
  };

  const onClickPaymentStatus = (data) => {
    setPaymentStatusText(data);
  };

  const onClickResetFilter = () => {
    setOrderTypeText("");
    setPaymentTypeText("");
    setPaymentStatusText("");
    setOrderType(false);
    setPaymentType(false);
    setPaymentStatus(false);
    props.orderTypeData("");
    props.paymentTypeData("");
    props.paymentStatusData("");
    handleCloseModal();
  };

  const onClickApplyFilter = () => {
    props.orderTypeData(orderTypeText);
    props.paymentTypeData(paymentTypeText);
    props.paymentStatusData(paymentStatusText);
    setOrderType(false);
    setPaymentType(false);
    setPaymentStatus(false);
    handleCloseModal();
  };

  return (
    <React.Fragment>
      <div
        onClick={onOpenModal}
        className="d-flex align-items-center justify-content-between cursor"
      > 
      <Media query="(min-width: 992px)">
        <Image
          alt="filter"
          title="filter"
          width="80px"
          src={require("../../../../assets/images/seatingImages/filter.svg")}
        />
        </Media>
        <Media query="(max-width: 992px)">
        <Image
        alt="filter"
        title="filter"
        width="40px"
        src={require("../../../../assets/images/ActionImages/pwa filter-img.png")}
         />
        </Media>
        {/* <div className="f12-500 text-blue mx-2">Filter</div>
        <i className="fa fa-angle-down text-blue" aria-hidden="true"></i> */}
      </div>
      <Media query="(min-width:991px)">
      <Modal show={state.open} onHide={handleCloseModal} centered>
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <Modal.Title className="f24_700_HelveticaNeue">Filter</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="f16-500 pb-4">
            Select one relevant option from below
          </div>
          <div className="d-flex align-items-center pb-4 justify-content-between">
            <label className="enRadioWithText f12-500 mr-4">
              Order Type
              <input
                type="radio"
                name="CouponDiscountType"
                checked={orderType}
                onChange={() => {
                  setOrderType(true);
                  setPaymentType(false);
                  setPaymentStatus(false);
                }}
              />
              <span className="checkmark"></span>
            </label>
            <label className="enRadioWithText f12-500 mr-4">
              Payment Type
              <input
                type="radio"
                name="CouponDiscountType"
                checked={paymentType}
                onChange={() => {
                  setOrderType(false);
                  setPaymentType(true);
                  setPaymentStatus(false);
                }}
              />
              <span className="checkmark"></span>
            </label>
            <label className="enRadioWithText f12-500 mr-4">
              Payment Status
              <input
                type="radio"
                name="CouponDiscountType"
                checked={paymentStatus}
                onChange={() => {
                  setOrderType(false);
                  setPaymentType(false);
                  setPaymentStatus(true);
                }}
              />
              <span className="checkmark"></span>
            </label>
          </div>

          <div className="d-flex flex-wrap align-items-center">
            {orderType && orderType === true
              ? ORDER_TYPE_FILTER.filter((e) => {
                  if (props?.orderingServices[e?.ref]?.value) return true;
                  return false;
                }).map((data, index) => {
                  return (
                    <Col xs={4} key={index} className="mobile-p-0">
                      <PopupInsideButton
                        buttonClass={
                          orderTypeText === data.value
                            ? "status-selected-button-box f11-700 mobile-f12-400 sts_sld_btn_box_a"
                            : "status-selected-button-box f11-700 mobile-f12-400"
                        }
                        buttonText={data.title}
                        buttonType="button"
                        onClick={(e) => onClickOrderType(data.value)}
                      />
                    </Col>
                  );
                })
              : null}
          </div>
          <div className="d-flex flex-wrap align-items-center">
            {paymentType && paymentType === true
              ? PAYMENT_TYPE_FILTER.map((data, index) => {
                  return (
                    <Col xs={4} key={index} className="mobile-p-0">
                      <PopupInsideButton
                        buttonClass={
                          paymentTypeText === data.value
                            ? "status-selected-button-box f11-700 mobile-f12-400 sts_sld_btn_box_a"
                            : "status-selected-button-box f11-700 mobile-f12-400"
                        }
                        buttonText={data.title}
                        buttonType="button"
                        onClick={(e) => onClickPaymentType(data.value)}
                      />
                    </Col>
                  );
                })
              : null}
          </div>
          <div className="d-flex flex-wrap align-items-center">
            {paymentStatus && paymentStatus === true
              ? PAYMENT_METHOD_STATUS_FILTER.map((data, index) => {
                  return (
                    <Col xs={4} key={index} className="mobile-p-0">
                      <PopupInsideButton
                        buttonClass={
                          paymentStatusText === data.value
                            ? "status-selected-button-box f11-700 mobile-f12-400 sts_sld_btn_box_a"
                            : "status-selected-button-box f11-700 mobile-f12-400"
                        }
                        buttonText={data.title}
                        buttonType="button"
                        onClick={(e) => onClickPaymentStatus(data.value)}
                      />
                    </Col>
                  );
                })
              : null}
          </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-start border-0">
          <Modal.Footer className="justify-content-start border-0">
            <Button
              variant="outline-secondary"
              className="btn-lg mr-4 px-5"
              onClick={onClickResetFilter}
            >
              Reset Filter
            </Button>
            <Button
              variant="danger"
              className="btn-lg px-5"
              onClick={onClickApplyFilter}
            >
              Apply Filter
            </Button>
          </Modal.Footer>
        </Modal.Footer>
      </Modal>
      </Media>


      <Media query="(max-width:992px)">
      <Modal show={state.open} onHide={handleCloseModal} centered>
        <Modal.Header className="py-0 pt-2 border-0 center" closeButton>
          <Modal.Title className="f24_700_HelveticaNeue">Filter</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="f16-500 pb-4">
            Select one relevant option from below
          </div>
          <div className="d-flex align-items-center pb-4 justify-content-between">
            <label className="enRadioWithText f12-500 mr-4">
              Order Type
              <input
                type="radio"
                name="CouponDiscountType"
                checked={orderType}
                onChange={() => {
                  setOrderType(true);
                  setPaymentType(false);
                  setPaymentStatus(false);
                }}
              />
              <span className="checkmark"></span>
            </label>
            <label className="enRadioWithText f12-500 mr-4">
              Payment Type
              <input
                type="radio"
                name="CouponDiscountType"
                checked={paymentType}
                onChange={() => {
                  setOrderType(false);
                  setPaymentType(true);
                  setPaymentStatus(false);
                }}
              />
              <span className="checkmark"></span>
            </label>
            <label className="enRadioWithText f12-500 mr-4">
              Payment Status
              <input
                type="radio"
                name="CouponDiscountType"
                checked={paymentStatus}
                onChange={() => {
                  setOrderType(false);
                  setPaymentType(false);
                  setPaymentStatus(true);
                }}
              />
              <span className="checkmark"></span>
            </label>
          </div>

          <div className="d-flex flex-wrap align-items-center">
            {orderType && orderType === true
              ? ORDER_TYPE_FILTER.filter((e) => {
                  if (props?.orderingServices[e?.ref]?.value) return true;
                  return false;
                }).map((data, index) => {
                  return (
                    <Row xs={4} key={index} className="mobile-p-0 ml-2 mr-2">
                      <PopupInsideButton
                        buttonClass={
                          orderTypeText === data.value
                            ? "status-selected-button-box f11-700 mobile-f12-400 sts_sld_btn_box_a"
                            : "status-selected-button-box f11-700 mobile-f12-400"
                        }
                        buttonText={data.title}
                        buttonType="button"
                        onClick={(e) => onClickOrderType(data.value)}
                        style={{minHeight:"40px"}}
                      />
                    </Row>
                  );
                })
              : null}
          </div>
          <div className="d-flex flex-wrap align-items-center">
            {paymentType && paymentType === true
              ? PAYMENT_TYPE_FILTER.map((data, index) => {
                  return (
                    <Row xs={4} key={index} className="mobile-p-0 ml-2 mr-2">
                      <PopupInsideButton
                        buttonClass={
                          paymentTypeText === data.value
                            ? "status-selected-button-box f11-700 mobile-f12-400 sts_sld_btn_box_a"
                            : "status-selected-button-box f11-700 mobile-f12-400"
                        }
                        buttonText={data.title}
                        buttonType="button"
                        onClick={(e) => onClickPaymentType(data.value)}
                        style={{minHeight:"40px"}}
                      />
                    </Row>
                  );
                })
              : null}
          </div>
          <div className="d-flex flex-wrap align-items-center">
            {paymentStatus && paymentStatus === true
              ? PAYMENT_METHOD_STATUS_FILTER.map((data, index) => {
                  return (
                    <Row xs={4} key={index} className="mobile-p-0 ml-2 mr-2">
                      <PopupInsideButton
                        buttonClass={
                          paymentStatusText === data.value
                            ? "status-selected-button-box f11-700 mobile-f12-400 sts_sld_btn_box_a"
                            : "status-selected-button-box f11-700 mobile-f12-400"
                        }
                        buttonText={data.title}
                        buttonType="button"
                        onClick={(e) => onClickPaymentStatus(data.value)}
                        style={{minHeight:"40px"}}
                      />
                    </Row>
                  );
                })
              : null}
          </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-start border-0">
          <Modal.Footer className="justify-content-start border-0">
            <Button
              variant="outline-secondary"
              className="btn-lg mr-4 px-5"
              onClick={onClickResetFilter}
              style={{
                minHeight:"48px"
              }}
            >
              Reset Filter
            </Button>
            <Button
              variant="danger"
              className="btn-lg px-5"
              onClick={onClickApplyFilter}
              style={{
                minHeight:"48px"
              }}
            >
              Apply Filter
            </Button>
          </Modal.Footer>
        </Modal.Footer>
      </Modal>
      </Media>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  notification: state.notifications,
  auth: state.auth,
  errors: state.errors.errors,
  orderingServices: state?.onboarding?.onboard_subscription_details
    ?.casual_dining_status?.ordering?.value
    ? state?.onboarding?.onboard_subscription_details?.casual_dining_status
        ?.ordering
    : state?.onboarding?.onboard_subscription_details?.fast_food_dining_status
        ?.ordering?.value
    ? state?.onboarding?.onboard_subscription_details?.fast_food_dining_status
        ?.ordering
    : state?.onboarding?.onboard_subscription_details
        ?.multi_service_business_status?.ordering?.value
    ? state?.onboarding?.onboard_subscription_details
        ?.multi_service_business_status?.ordering
    : "",
});

export default connect(mapStateToProps, {})(withRouter(OrderFilterSection));

// export default OrderFilterSection;
